import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Eyebrow, Reveal } from "../Reveal";
import { PHONE, PHONE_HREF } from "../../data/site";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="grain relative overflow-hidden bg-charcoal">
    <div className="container-cando section-pad relative">
      <Reveal className="flex">
        <Eyebrow dark>Next Step</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="h2 mt-6 max-w-3xl text-warm" style={{ fontSize: "clamp(2.25rem, 1.6rem + 3vw, 3.75rem)" }}>
          Ready to Build Something Better?
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="lead mt-6 max-w-xl text-warm/65">
          Tell us what you're planning. We'll help you take the next step.
        </p>
      </Reveal>
      <Reveal delay={0.24}>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link to="/contact" data-testid="final-cta-estimate" className="btn btn-bronze group">
            Request a Project Estimate
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <a href={PHONE_HREF} data-testid="final-cta-call" className="btn btn-outline-light">
            <Phone size={15} />
            Call {PHONE}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
